import DateFilter from '@/components/date-filter';
import store_examen from '@/store/mods/consultations/consultations'
import ManageInterpretation from '@/views/examens/attente-interpretations/manage-interpretation'
import $ from 'jquery'


export default {
    name: 'attente-interpretations',
    components: {
        DateFilter, ManageInterpretation
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            is_loading: true,
            is_empty: false,
            is_error: false,
            liste_examens_attente: [],

            fields: [
                'patient', 'sexe', 'date', 'examen',
                { key: 'action', label: 'Action.s' }
            ],
			filter: '',
			perPage: 25,
			currentPage: 1,
            selected_examen: {},
            toggler: 0,

            user_info: {}
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                user_id: this.userCredentials.id
            }
            this.current_date_filter = data
            this.is_month = true
            this.getListeExamenAttenteInterpretation()
        },
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            user_id: this.userCredentials.id
        }
        this.current_date_filter = data
        this.getListeExamenAttenteInterpretation()

        this.setUserInfo()
    },

    methods: {
        setUserInfo() {
            this.user_info = {
                id: this.userCredentials.id,
                nom: this.userCredentials.name,
                titre: this.userCredentials.titre,
            }
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                user_id: this.userCredentials.id
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListeExamenAttenteInterpretation()
        },

        getListeExamenAttenteInterpretation() {
            this.liste_examens_attente = []
            this.is_loading = true

            store_examen.getExamensAttenteInterpretation(this.current_date_filter).then((response) => {
                this.liste_examens_attente = response
                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }
                this.is_loading = false
                this.examens = response
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        setExamToComment(data) {
            this.toggler = (this.toggler == 0)?1:0
            this.selected_examen = data

            $('.interpret-exm').modal('show')
        }
    }
}